"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allDesktopSharingDestinations = exports.fallbackShareSheetShareDestinations = exports.defaultShareSheetShareDestinations = exports.defaultShareBarShareDestinations = exports.Embed = exports.Messages = exports.More = exports.TikTok = exports.CopyLink = exports.EmailV2 = exports.Snapchat = exports.Pinterest = exports.Reddit = exports.Facebook = exports.Twitter = exports.WhatsApp = exports.Messenger = void 0;
const event_1 = require("@snapchat/ts-protos/event");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const device_detection_1 = require("./device-detection");
const offPlatformShareEnums_1 = require("./offPlatformShareEnums");
const web_env_1 = require("@snapchat/web-env");
const getMessagesIcon = () => {
    const deviceType = (0, device_detection_1.getMobileDeviceType)();
    switch (deviceType) {
        case device_detection_1.DeviceType.ANDROID:
            return (0, web_core_ui_1.MessagesIcon)();
        case device_detection_1.DeviceType.iOS:
            return (0, web_core_ui_1.iMessageIcon)();
        default:
            return (0, web_core_ui_1.iMessageIcon)();
    }
};
function Messenger(isMobile, inputs) {
    return {
        id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.MESSENGER,
        shareDestination: event_1.WebShareDestination.MESSENGER,
        icon: web_core_ui_1.MessengerIcon,
        shareBaseUrl: isMobile || !inputs
            ? undefined
            : `https://www.facebook.com/dialog/send?redirect_uri=${inputs.redirectUri}&app_id=${inputs.appId}&link=`,
    };
}
exports.Messenger = Messenger;
function WhatsApp(isMobile) {
    return {
        id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.WHATSAPP,
        shareDestination: event_1.WebShareDestination.WHATSAPP,
        icon: web_core_ui_1.WhatsappIcon,
        shareBaseUrl: isMobile ? "whatsapp://send?text=" : "https://api.whatsapp.com/send?text=",
    };
}
exports.WhatsApp = WhatsApp;
exports.Twitter = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.TWITTER,
    shareDestination: event_1.WebShareDestination.TWITTER,
    icon: web_core_ui_1.TwitterIcon,
    shareBaseUrl: "https://twitter.com/intent/tweet?text=",
};
exports.Facebook = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.FACEBOOK,
    shareDestination: event_1.WebShareDestination.FACEBOOK,
    icon: web_core_ui_1.FacebookIcon,
    shareBaseUrl: "https://www.facebook.com/sharer/sharer.php?u=",
};
exports.Reddit = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.REDDIT,
    shareDestination: event_1.WebShareDestination.REDDIT,
    icon: web_core_ui_1.RedditIcon,
    shareBaseUrl: "https://www.reddit.com/submit?url=",
};
exports.Pinterest = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.PINTEREST,
    shareDestination: event_1.WebShareDestination.PINTEREST,
    icon: web_core_ui_1.PinterestIcon,
    shareBaseUrl: "https://pinterest.com/pin/create/link/?url=",
};
exports.Snapchat = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.SNAPCHAT,
    shareDestination: event_1.WebShareDestination.WEB_SHARE_TO_SNAPCHAT,
    icon: web_core_ui_1.SnapchatIcon,
    shareBaseUrl: "https://snapchat.com/scan?attachmentUrl=",
};
function EmailV2() {
    return {
        id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.EMAIL,
        shareDestination: event_1.WebShareDestination.MAIL,
        icon: () => (0, web_core_ui_1.EmailIcon)(),
        shareBaseUrl: "mailto:?to=&body=",
    };
}
exports.EmailV2 = EmailV2;
exports.CopyLink = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.COPY_LINK,
    shareDestination: event_1.WebShareDestination.COPY_LINK,
    icon: web_core_ui_1.CopyLinkIcon,
    title: offPlatformShareEnums_1.OffPlatformShareDestinationTitle.COPY_LINK,
    mobileTooltipComponent: ({ intl }) => (0, web_core_ui_1.Tooltip)({
        message: intl.formatMessage({
            id: "8y4OLC",
            defaultMessage: "URL Copied!",
            description: "URL Copied tooltip text",
        }),
        position: web_core_ui_1.Position.RIGHT,
    }),
};
exports.TikTok = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.TIKTOK,
    shareDestination: event_1.WebShareDestination.TIKTOK,
    icon: web_core_ui_1.TiktokIcon,
};
exports.More = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.MORE,
    shareDestination: event_1.WebShareDestination.WEB_SHARE_API,
    icon: web_core_ui_1.MoreIcon,
};
exports.Messages = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.MESSAGES,
    shareDestination: event_1.WebShareDestination.MESSAGES,
    icon: getMessagesIcon,
    shareBaseUrl: "sms:?&body=",
};
exports.Embed = {
    id: offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.EMBED,
    shareDestination: event_1.WebShareDestination.EMBED,
    icon: web_core_ui_1.EmbedIcon,
};
exports.defaultShareBarShareDestinations = [
    exports.Facebook,
    exports.Twitter,
    WhatsApp(false),
    exports.Reddit,
    exports.Pinterest,
];
function defaultShareSheetShareDestinations(withEmbed) {
    const items = [exports.CopyLink, WhatsApp(true), Messenger(true), exports.TikTok, exports.Facebook, exports.Twitter, exports.More];
    if (withEmbed) {
        items.push(exports.Embed);
    }
    return items;
}
exports.defaultShareSheetShareDestinations = defaultShareSheetShareDestinations;
function fallbackShareSheetShareDestinations(withEmbed) {
    const items = [exports.CopyLink, exports.Messages, WhatsApp(true)];
    if (withEmbed) {
        items.push(exports.Embed);
    }
    return items;
}
exports.fallbackShareSheetShareDestinations = fallbackShareSheetShareDestinations;
const allDesktopSharingDestinations = (withSnapchat = false) => {
    const windowObj = (0, web_env_1.getWindow)();
    const redirectUri = (typeof windowObj !== "undefined" && windowObj.location.origin) || "https://www.snapchat.com";
    const fbAppId = "3036080273278005";
    const destinations = [
        ...exports.defaultShareBarShareDestinations,
        EmailV2(),
        Messenger(false, { appId: fbAppId, redirectUri }),
    ];
    if (withSnapchat) {
        destinations.push(exports.Snapchat);
    }
    return destinations;
};
exports.allDesktopSharingDestinations = allDesktopSharingDestinations;
//# sourceMappingURL=shareDestinations.js.map